import {
   Box,
   Button,
   FormControl,
   Grid,
   InputLabel,
   MenuItem,
   Select,
   TextField,
   Chip,
   Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { views } from "./defineUtils";
import { useDispatch, useSelector } from "react-redux";
import { GetQuotaChartData, setState } from "./defineSlice";
import {
   DrawRounded,
   TaskAltRounded,
   DoNotDisturbOutlined,
   Translate,
} from "@mui/icons-material";

export default function ViewSearchRefresh() {
   const dispatch = useDispatch();
   const define = useSelector((store) => store.define);
   const { searchText, selectedView, gridData, filter_customerTypes, filter_customerTrustLevels, filter_skuName, selectedProduct, selectedQuota, TotalAdjustment,
      TotalSafetyMargin,
      TotalUnusedQuota,
      showMiddleBox,
      TotalQuota, } = define;

   function setView(event) {
      const value = event.target.value;
      dispatch(setState("selectedView", value));
   }

   function setSearchText(event) {
      let text = event.target.value;
      dispatch(setState("searchText", text));
      handleSearch(text);
   }

   function handleSearch(str) {
      if (str.length === 0) {
         let val = gridData?.filter((item) => {
            return (
               (filter_customerTypes.length === 0 || filter_customerTypes.some(type => item.type.toLowerCase().includes(type.toLowerCase()))) &&
               (filter_customerTrustLevels.length === 0 || filter_customerTrustLevels.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
               (filter_skuName.length === 0 || filter_skuName.some(sku => item.skuName.toLowerCase().includes(sku.toLowerCase()))) &&
               (selectedProduct.packGroupOrSKUID === 0 || selectedProduct.packGroupOrSKUID === undefined || item.skuid === selectedProduct.packGroupOrSKUID)
            );
         });
         dispatch(setState("gridDataFiltered", val));
         return;
      }
      let text = str.toLowerCase();
      // let searchedItems = [];
      // gridData.forEach((item) => {
      //    const flag =
      //       item.skuName?.toLowerCase().includes(text) ||
      //       item.skuNumb?.toLowerCase().includes(text) ||
      //       item.customerName?.toLowerCase().includes(text) ||
      //       item.customerGroupName?.toLowerCase().includes(text) ||
      //       item.customerNumber?.toLowerCase().includes(text);
      //    if (flag) {
      //       searchedItems.push(item);
      //    }
      // });
      // console.log("Define_ViewSearchRefresh_handleSearch", text, searchedItems);
      // dispatch(setState("gridDataFiltered", []));
      // dispatch(setState("gridDataFiltered", searchedItems));

      let val = gridData?.filter((item) => {
         return (
            (filter_customerTypes.length === 0 || filter_customerTypes.some(type => item.type.toLowerCase().includes(type.toLowerCase()))) &&
            (filter_customerTrustLevels.length === 0 || filter_customerTrustLevels.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
            (filter_skuName.length === 0 || filter_skuName.some(sku => item.skuName.toLowerCase().includes(sku.toLowerCase()))) &&
            (selectedProduct.packGroupOrSKUID === 0 || selectedProduct.packGroupOrSKUID === undefined || item.skuid === selectedProduct.packGroupOrSKUID || item.productGroupID === selectedProduct.packGroupOrSKUID) &&
            (item.skuName?.toLowerCase().includes(text) ||
               item.skuNumb?.toLowerCase().includes(text) ||
               item.customerName?.toLowerCase().includes(text) ||
               item.customerGroupName?.toLowerCase().includes(text) ||
               item.customerNumber?.toLowerCase().includes(text))
         );
      });
      dispatch(setState("gridDataFiltered", val));
   }

   function refresh() {
      dispatch(GetQuotaChartData({ method: "POST" }));
   }

   return (
      <Box sx={{ mt: 2, mb: 2 }}>
         <Grid container columns={12} spacing={2}>
            <Grid item xs={12} md={2.5}>
               <FormControl variant={"outlined"}>
                  <Select value={selectedView} onChange={setView}>
                     {views.map((item, index) => {
                        return (
                           <MenuItem key={index} value={item.key}>
                              {item.value}
                           </MenuItem>
                        );
                     })}
                  </Select>
               </FormControl>
            </Grid>

            <Grid item xs={12} md={2.5}>
               <TextField
                  variant="outlined"
                  placeholder="search"
                  value={searchText}
                  onChange={setSearchText}
               />
            </Grid>
         
            <Grid item xs={12} md={1}>
               <Button sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  fontWeight: "700",
                  height: "42px",
                  textTransform: "none",
                  "&:hover": {
                     bgcolor: "darkred.main",

                  },
               }}
                  variant="contained" onClick={refresh}>Refresh</Button>
            </Grid>
            {showMiddleBox && ( 
            <Grid item xs={12} sm={5.9} md={5.9} lg={5.9} style = {{opactity: showMiddleBox ? 1: 0, transition : "opactity 1.8s ease-in-out"}}>
               <Grid
                  container
                  columns={12}
                  justifyContent="space-between"
               >
                  <Grid item xs={12} sm={12} md={3.5} lg={3.5} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                     <Typography sx={{ fontSize: "14px", fontWeight: "500"
                     }}> 
                        Quota status
                        <Chip
                           icon={
                              (selectedQuota?.quotaStatus === "Approved" && (
                                 <TaskAltRounded />
                              )) ||
                              (selectedQuota?.quotaStatus ===
                                 "Locally Approved" && <TaskAltRounded />) ||
                              (selectedQuota?.quotaStatus === "Draft" && (
                                 <DrawRounded />
                              )) ||
                              (selectedQuota?.quotaStatus === "Submitted" && (
                                 <DrawRounded />
                              )) ||
                              (selectedQuota?.quotaStatus === "Rejected" && (
                                 <DrawRounded />
                              )) ||
                              (selectedQuota?.quotaStatus === "Invalid" && (
                                 <DrawRounded />
                              )) ||
                              ((selectedQuota?.quotaStatus === null ||
                                 selectedQuota?.quotaStatus === " ") && (
                                    <DoNotDisturbOutlined />
                                 ))
                           }
                           label={
                              selectedQuota?.quotaStatus === null ||
                                 selectedQuota?.quotaStatus === " "
                                 ? "N/A"
                                 : selectedQuota?.quotaStatus
                           }
                           color={
                              (selectedQuota?.quotaStatus === "Approved" &&
                                 "success") ||
                              (selectedQuota?.quotaStatus ===
                                 "Locally Approved" &&
                                 "success") ||
                              (selectedQuota?.quotaStatus === "Draft" &&
                                 "info") ||
                              (selectedQuota?.quotaStatus === "Submitted" &&
                                 "info") ||
                              (selectedQuota?.quotaStatus === "Rejected" &&
                                 "error") ||
                              (selectedQuota?.quotaStatus === "Invalid" &&
                                 "error") ||
                              ((selectedQuota?.quotaStatus === null ||
                                 selectedQuota?.quotaStatus === " ") &&
                                 "error")
                           }
                           variant="outlined"
                           size="small"
                           sx={{ ml: 1, p: 1 }}
                        />
                     </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={8.5} lg={8.5}>
                     <Box className="quota_details_layout_middle">
                        <Grid
                           container
                           columns={12}
                           justifyContent="space-around"
                           //columnGap={1}
                        >
                           <Grid item xs={5} lg={2.5}>
                              <Typography className="quota_numbers_middle">
                                 {TotalAdjustment?.toLocaleString('en-US')}
                                 <Typography className="quota_labels_middle">
                                    Total Adjustments
                                 </Typography>
                              </Typography>
                           </Grid>
                           <Grid item xs={5} lg={2.65}>
                              <Typography className="quota_numbers_middle">
                                 {TotalSafetyMargin?.toLocaleString('en-US')}
                                 <Typography className="quota_labels_middle">
                                    Total Safety Margin
                                 </Typography>
                              </Typography>
                           </Grid>
                           <Grid item xs={5} lg={3}>
                              <Typography className="quota_numbers_middle">
                                 {TotalUnusedQuota?.toLocaleString('en-US')}
                                 <Typography className="quota_labels_middle">
                                    Total Unused Quota
                                 </Typography>
                              </Typography>
                           </Grid>
                           <Grid item xs={5} lg={1.85}>
                              <Typography className="quota_numbers_middle">
                                 {TotalQuota?.toLocaleString('en-US')}
                                 <Typography className="quota_labels_middle">
                                    Total Quota
                                 </Typography>
                              </Typography>
                           </Grid>
                        </Grid>
                     </Box>
                  </Grid>
               </Grid>
            </Grid>
            )}
         </Grid>
      </Box>
   );
}